export default {
  sfmInsuranceTypeKeyDefault: 'sfm',
  sfiInsuranceTypeKey: 'sfi',
  logoPosition: {
    sfm: {
      header: {
        marginTop: '17px',
        width: '130px'
      },
      footer: {
        marginTop: '34px',
        width: '130px'
      }
    },
    sfi: {
      header: {
        marginTop: '10px',
        width: '185px'
      },
      footer: {
        marginTop: '34px',
        width: '185px'
      }
    }
  },
  prettyScheduleMap: {
    inputRegEx: /([A-Z]{3})-?([A-Z]{3})?,([1-2]?[0-9]:[0-5][0-9] [AP]M)-([1-2]?[0-9]:[0-5][0-9] [AP]M)/,
    days: {
      MON: ['Monday', 'M'],
      TUE: ['Tuesday', 'T'],
      WED: ['Wednesday', 'W'],
      THU: ['Thursday', 'Th'],
      FRI: ['Friday', 'F'],
      SAT: ['Saturday', 'Sat'],
      SUN: ['Sunday', 'Sun']
    },
    AM: ['a.m.', 'am'],
    PM: ['p.m.', 'pm'],
    timezone: 'ET'
  },
  paymentInformation: {
    months: [
      { key: '01' }, { key: '02' }, { key: '03' }, { key: '04' }, { key: '05' }, { key: '06' },
      { key: '07' }, { key: '08' }, { key: '09' }, { key: '10' }, { key: '11' }, { key: '12' }
    ],
    yearsToShow: 20,
    paymentTypes: [
      {
        key: 'Card',
        description: 'Credit Card'
      },
      {
        key: 'eCheck',
        description: 'eCheck'
      }
    ],
    bankAccountTypes: [
      {
        key: 'Checking',
        description: 'Checking'
      },
      {
        key: 'Savings',
        description: 'Savings'
      }
    ],
    states: [
      { key: 'AL' }, { key: 'AK' }, { key: 'AZ' }, { key: 'AR' }, { key: 'CA' }, { key: 'CO' }, { key: 'CT' },
      { key: 'DE' }, { key: 'FL' }, { key: 'GA' }, { key: 'HI' }, { key: 'ID' }, { key: 'IL' }, { key: 'IN' },
      { key: 'IA' }, { key: 'KS' }, { key: 'KY' }, { key: 'LA' }, { key: 'ME' }, { key: 'MD' }, { key: 'MA' },
      { key: 'MI' }, { key: 'MN' }, { key: 'MS' }, { key: 'MO' }, { key: 'MT' }, { key: 'NE' }, { key: 'NV' },
      { key: 'NH' }, { key: 'NJ' }, { key: 'NM' }, { key: 'NY' }, { key: 'NC' }, { key: 'ND' }, { key: 'OH' },
      { key: 'OK' }, { key: 'OR' }, { key: 'PA' }, { key: 'RI' }, { key: 'SC' }, { key: 'SD' }, { key: 'TN' },
      { key: 'TX' }, { key: 'UT' }, { key: 'VT' }, { key: 'VA' }, { key: 'WA' }, { key: 'WV' }, { key: 'WI' },
      { key: 'WY' }
    ]
  },
  analyticsConstants: {
    FIND_YOUR_BILL: 'find-your-bill',
    PAYMENT_INFORMATION: 'payment-info',
    REVIEW_PAYMENT: 'review-payment',
    FAILED_PAYMENT: 'failed-payment',
    PAYMENT_SUCESSFUL: 'success-payment',
    SPECIALITY_ERROR: 'speciality-error',
    CONTACT_US: 'epayContactUsLink',
    CANCEL: 'epayCancelLink',
    findYourBill: {
      POLICY_NUMBER: 'epayPolicyNumbBox',
      WHERE_CAN_I_FIND_THIS: 'epayFindPolicyNumbLink',
      ZIP_CODE: 'epayPropZipCodeBox',
      FIND_MY_BILL: 'epayFindBillButton'
    },
    redirectPage: {
      PAYMENT_CENTER: 'epayPaymentCenterButton'
    },
    paymentInformation: {
      paymentAmount: {
        due: 'epayNextAmountDueButton',
        remaining: 'epayRemainBalButton',
        other: 'epayCustomAmountButton'
      },
      paymentMethod: {
        Card: 'epayCreditCardButton',
        eCheck: 'epayEcheckButton'
      },
      NAME_ON_CARD: 'epayNameCardBox',
      CARD_NUMBER: 'epayCardNumbBox',
      EXP_MONTH: 'epayExpirationMonthInputbox',
      EXP_YEAR: 'epayExpirationYearInputbox',
      CVV: 'epayCVVInputbox',
      CVV_HELP: 'epayQuestionMarkButton',
      FIRST_NAME: 'epayFirstNameInputbox',
      LAST_NAME: 'epayLastNameInputbox',
      STREET_ADDRESS: 'epayStreetAddressInputbox',
      APT_SUITE: 'epayAptSuiteInputbox',
      CITY: 'epayCityInputbox',
      STATE: 'epayStateInputbox',
      ZIP_CODE: 'epayZipCodeInputbox',
      REVIEW_PAYMENT: 'epayReviewPaymentButton'
    },
    reviewPayment: {
      CONFIRM_PAYMENT: 'epayConfirmPaymentButton',
      BACK: 'epayBackButton'
    },
    errorPage: {
      EDIT_PAYMENT_INFO: 'epayEditPaymentInfo'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/constants.js